const $elements = {
	tool:               document.querySelector( '.connectivity-checker' ),
	iframe:             document.querySelector( '.connectivity-checker__map iframe'),
	form:               document.querySelector( '#connectivity-checker-form' ),
	locationSearch:     document.querySelector( '#connectivity-checker-location-lookup' ),
	inputAddress:       document.querySelector( '#connectivity-checker-input-street-address' ),
	inputCity:          document.querySelector( '#connectivity-checker-input-city' ),
	inputPostalCode:    document.querySelector( '#connectivity-checker-input-postal-code' ),
	inputLatitude:      document.querySelector( '#connectivity-checker-input-latitude' ),
	inputLongitude:     document.querySelector( '#connectivity-checker-input-longitude' ),
	searchSubmit:       document.querySelector( '#connectivity-checker-form-submit' ),
	responseWrap:       document.querySelector( '.connectivity-checker__responses' ),
	responses:          document.querySelector( '.connectivity-checker__alerts' ),
	apiResponseLoading: document.querySelector( '.connectivity-checker__api-response--loading' ),
	apiResponseError:   document.querySelector( '.connectivity-checker__api-response--error' ),
	gravityFormWrap:    document.querySelector( '.connectivity-checker__response' ),
	gravityFormAddress: document.querySelector( '.connectivity-checker-user-address input[type="text"]' ),
	gravityFormStatus:  document.querySelector( '.connectivity-checker-user-status input[type="text"]' ),
};

/**
 * Updatess the map iframe to use a specific URL that targets the current
 * address.
 * 
 * @param {string} address 
 * @returns void
 */
const updateIframeLocation = ( address ) => {

	if ( ! $elements.iframe ) {
		return;
	}

	let url    = new URL( $elements.iframe.dataset.srcBase );
	let params = new URLSearchParams();

	params.set( 'full_address', address );
	params.set( 'lang', 'en' );
	params.set( 'no_header', 'true' );
	
	url.search = params.toString();

	$elements.iframe.src = url.href;
};


const updateDynamicFormFields = ( address ) => {

	if ( ! window.hasOwnProperty( 'coltConnectivityCheckerDynamicFieldIDs' ) ) {
		return;
	}

	let field_ids = window.coltConnectivityCheckerDynamicFieldIDs.map( id => `#input_${id}` );

	if ( ! field_ids.length ) {
		return;
	}

	field_ids.forEach( field_id => {
		let $field = document.querySelector( field_id );

		if ( ! $field ) {
			return;
		}

		$field.value = address;
	} );

};

/**
 * Create a google.maps.places.SearchBox instance, attach it, and bind any
 * required events.
 * 
 * @returns 
 */
const attachGooglePlacesSearch = () => {

	// If the search field doesn't exist, bail.
	if ( ! $elements.locationSearch ) {
		return;
	}

	// Create the instance.
	let search = new google.maps.places.SearchBox( $elements.locationSearch );

	// When the user has selected a location, run our changes.
	search.addListener( 'places_changed', () => {
		const results = search.getPlaces();
        
		if ( results.length < 1 ) {
			return;
		}
    
		let result  = results[0];

		/**
		 * We need to manually split out the address parts provided by Google's
		 * response here. Once we hae them separated, we can determine whether
		 * or not we need to update the hidden forms within the field.
		 */
		let address = document.createElement( 'div' );
        
		address.innerHTML = result.adr_address;

		let componentStreetAddress = address.querySelector( '.street-address' );
		let componentCity          = address.querySelector( '.locality' );
		let componentPostalCode    = address.querySelector( '.postal-code' );

		if ( componentStreetAddress ) {
		    $elements.inputAddress.value = componentStreetAddress.textContent;
		}

		if ( componentCity ) {
			$elements.inputCity.value = componentCity.textContent;
		}

		if ( componentPostalCode ) {
		    $elements.inputPostalCode.value = componentPostalCode.textContent;
		}

		address.remove();

		// Update the hidden latitude/longitude fields.
		$elements.inputLatitude.value   = result.geometry.location.lat();
		$elements.inputLongitude.value  = result.geometry.location.lng();

		// Ensure the iframe shows the user's location.
		updateIframeLocation( result.formatted_address );
		updateDynamicFormFields( result.formatted_address );

		// Automatically trigger an API request and enable the submit button.
		let event = new Event( 'click' );

		$elements.searchSubmit.dispatchEvent( event );
		$elements.searchSubmit.removeAttribute( 'disabled' );

		// Push the event to GTM.
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( {
			'event'   : 'connectivity-check-address-select',
			'address' : result.formatted_address,
		} );

		// Hide any response elements from a preview request.
		if ( $elements.apiResponseError ) {
			$elements.apiResponseError.style.display = 'none';
		}

		$elements.gravityFormWrap.classList.remove( 'connectivity-checker__response--active' );

		// Iterate through response children to reset any alerts to hidden once we've done another submission.
		[ ...$elements.responses.children ].forEach( ( alert ) => {
			alert.style.display = 'none';
		} );

	} );
};

const sendConnectivityCheckRequest = function ( event ) {

	event.preventDefault();

	const submission = new FormData( $elements.form );
	const request    = new XMLHttpRequest();
	const params     = new URLSearchParams();

	let url = new URL( $elements.form.attributes.getNamedItem( 'action' ).nodeValue );

	params.set( 'action', submission.get( 'action' ) );
	params.set( 'streetAddress', submission.get( 'streetAddress' ) );
	params.set( 'city', submission.get( 'city' ) );
	params.set( 'postalCode', submission.get( 'postalCode' ) );
	params.set( 'latitude', submission.get( 'latitude' ) );
	params.set( 'longitude', submission.get( 'longitude' ) );
	params.set( 'nonce', submission.get( 'nonce' ) );

	url.search = params.toString();

	request.open( 'GET', url.href, true );
	request.responseType = 'json';

	$elements.form.classList.add( 'connectivity-checker__form--loading' );

	if ( $elements.apiResponseLoading ) {
		$elements.apiResponseLoading.style.display = 'block';
	}

	request.onreadystatechange = function () {
		if ( request.readyState === XMLHttpRequest.DONE ) {

			// Remove the loading "state" on the form and hide the text.
			$elements.form.classList.remove( 'connectivity-checker__form--loading' );

			if ( $elements.apiResponseLoading ) {
				$elements.apiResponseLoading.style.display = 'none';
			}
            
			// If we have any other HTTP status response, show an API error.
			if ( request.status !== 200 ) {
				if ( $elements.apiResponseError ) {
					$elements.apiResponseError.style.display = 'block';
				}

				return;
			}

			let response = request.response;

			// If we have a response but it was unsuccessful, show an API error.
			if ( response.hasOwnProperty( 'success' ) && false === response.success && $elements.apiResponseError ) {
				$elements.apiResponseError.style.display = 'block';

				return;
			}

			// Not pretty...
			let connectivityResponse = response.response.checkConnectivityResponse.checkConnectivityResponse;

			/**
			 * Determine whether or not the repsonse property is actually able
			 * to use a Colt line with the "AVAILABLE" state, and by falling
			 * back to checking the "Near Net" and "Off Net" statuses. This
			 * determines which of the three responses will show.
			 * 
			 * We also derive what type of line is available, and insert that into a
			 * hidden field so we can use it in the gravity form submission.
			 * 
			 * net_type_responses are drawn in from string localisation in the
			 * index.php file.
			 */
			let $response;
			let responseStatus = window.coltConnectivityCheckerNetTypeResponses.offNet;

			if ( connectivityResponse.response === 'NOT-AVAILABLE' ) {
				$response = $elements.responseWrap.querySelector( '.connectivity-checker__response--off-net' );
			} else if (
				connectivityResponse.response === 'AVAILABLE' &&
				connectivityResponse.hasOwnProperty( 'localSiteAddress' )
			) {
				let site = connectivityResponse.localSiteAddress;

				if ( site.onNetStatus.status === 'AVAILABLE' ) {
					responseStatus = window.coltConnectivityCheckerNetTypeResponses.onNet;
					$response      = $elements.responseWrap.querySelector( '.connectivity-checker__response--on-net' );
				} else if ( site.nearNetStatus.hasOwnProperty( 'status' ) && site.nearNetStatus.status === 'AVAILABLE' ) {
					responseStatus = window.coltConnectivityCheckerNetTypeResponses.nearNet;
					$response      = $elements.responseWrap.querySelector( '.connectivity-checker__response--near-net' );
				} else {
					$response = $elements.responseWrap.querySelector( '.connectivity-checker__response--off-net' );
				}
			} else {
				$response = $elements.responseWrap.querySelector( '.connectivity-checker__response--off-net' );
			}

			// Ensure we have a valid response and display it.
			// Now the form is separate to the message, we also display that.
			if ( $response ) {
				$response.style.display = 'block';
				$elements.gravityFormWrap.classList.add( 'connectivity-checker__response--active' );

				if ( $elements.gravityFormStatus ) {
					$elements.gravityFormStatus.value = responseStatus;
				}

			}
		}
	};

	request.send();

	return false;

};

/**
 * This is in place purely to make sure the map is always the same height as the
 * actual tool because, by default, it isn't. So whenever the iframe resizes, we
 * need to reload the inner contents so that the map gets the appropriate
 * height.
 * 
 * @return void
 */
const configureResizeObservationForIframe = () => {
	let currentHeight = $elements.iframe.clientHeight;

	let observer = new ResizeObserver( els => {
		els.forEach( ( el ) => {
			let iframe = el.target;

			if ( ! iframe || iframe.clientHeight === currentHeight ) {
				return;
			}

			currentHeight = iframe.clientHeight;
			iframe.src    = iframe.src;
		} );
	} );

	observer.observe( $elements.iframe );
};

/**
 * Initial setup function.
 * 
 * @returns void
 */
const setupConnectivityChecker = () => {

	if ( ! $elements.tool ) {
		return;
	}

	// Attach events.
	$elements.form.addEventListener( 'submit', ( event ) => event.preventDefault() );
	$elements.searchSubmit.addEventListener( 'click', sendConnectivityCheckRequest );
	$elements.iframe.addEventListener( 'load', configureResizeObservationForIframe );

	// Perform initial setup functionals.
	attachGooglePlacesSearch();

};

export {
	setupConnectivityChecker,
};
